import React from "react";
import { RaketaUIProvider } from "@raketa-cms/raketa-cms";
import { MediaManagerContext } from "@raketa-cms/raketa-image-picker";
import SelectMenu from "../../Fields/SelectMenu/SelectMenu";
import AvailableProductsInput from "./AvailableProductsInput";
import IntegrationsInput from "./IntegrationsInput";
import SectionsInput from "./SectionsInput";
import MediaManager from "components/cms/MediaManager";

const mediaManager = new MediaManager("/");

const PlanFeatureSettings = ({
  settings_value,
  type_value,
  settings_name,
  type_name,
  types,
  type_error,
}) => {
  const [settingsValue, setSettingsValue] = React.useState(settings_value);
  const [typeValue, setTypeValue] = React.useState(type_value);

  return (
    <RaketaUIProvider>
      <MediaManagerContext.Provider value={mediaManager}>
        <div className="field-pannel form-group">
          <SelectMenu
            options={types}
            value={typeValue}
            label="Feature type"
            placeholder="Please select..."
            required
            error={type_error}
            onChange={(event) => {
              setTypeValue(event.target.value);
              setSettingsValue({});
            }}
          />

          {typeValue === "products" && (
            <AvailableProductsInput
              value={settingsValue || {}}
              onChange={setSettingsValue}
            />
          )}

          {typeValue === "integrations" && (
            <IntegrationsInput
              value={settingsValue || {}}
              onChange={setSettingsValue}
            />
          )}

          {typeValue === "sections" && (
            <SectionsInput
              value={settingsValue || {}}
              onChange={setSettingsValue}
            />
          )}

          <input type="hidden" name={type_name} defaultValue={typeValue} />
          <input
            type="hidden"
            name={settings_name}
            defaultValue={JSON.stringify(settingsValue)}
          />
        </div>
      </MediaManagerContext.Provider>
    </RaketaUIProvider>
  );
};

export default PlanFeatureSettings;
